import cn from 'classnames';
import { ReactComponent as ArrowIcon } from '@packages/shared/assets/arrow-gradient.svg';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import Header from '@packages/shared/core/common/components/layout/Header';
import { OfferScreenProps } from '@packages/shared/core/quiz/entities';
import Button from '@packages/shared/core/common/components/common/Button';
import styles from './OfferScreen.module.scss';

const OfferScreen = (props: OfferScreenProps) => {
  const { goal, goBack, redirectToChat } = props;
  return (
    <>
      <div className={styles.background} />

      <div className={styles.container}>
        <Header className={styles.header} menuClassName={styles.menu}>
          <ButtonBack className={styles.buttonBack} secondary onClick={goBack} />
        </Header>

        <div className={styles.contentWrapper}>
          <h2 className={styles.title}>
            {`${goal} with AskNebula!`}

            <br />

            <span className={styles.highlight}>First minutes are on us</span>
          </h2>

          <h2 className={styles.subtitle}></h2>

          <div className={styles.descriptionWrapper}>
            <div className={styles.circle} />

            <div className={styles.descriptionTitle}>Special offer:</div>
          </div>

          <div className={cn(styles.descriptionWrapper, styles.descriptionTextWrapper)}>
            <div className={styles.bottomLine} />

            <div className={styles.descriptionText}>
              <span className={styles.descriptionTextBold}>FREE minutes with selected psychic</span>
            </div>
          </div>

          <div className={styles.descriptionWrapper}>
            <div className={styles.circle} />

            <div className={styles.descriptionTitle}>No credit card required</div>
          </div>

          <div className={styles.descriptionArrowWrapper}>
            <ArrowIcon className={styles.arrow} />
          </div>

          <div className={styles.buttonBlockWrapper}>
            <div className={styles.buttonBlock}>
              <span className={styles.buttonText}>Claim your free minutes</span>

              <Button
                data-testid="claim-offer-button"
                className={styles.button}
                wrapperClassName={styles.buttonWrapper}
                onClick={redirectToChat}
              >
                Claim
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferScreen;
